export default "__VITE_ASSET__bc350d28__"